import { createFileRoute } from "@tanstack/react-router";
import Motociclete from "@/pages/Motociclete";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/motorräder/")({
  head: () => routeHead("/de/motorräder/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Motociclete />
  );
}
